<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstVisitorPass"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedVisitorPass"
		dataKey="VisitorPassID"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--Barcode-->
				<th>
					<p-columnFilter type="text" field="Barcode" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--VisitorPassDT-->
				<th>
					<!-- <p-columnFilter type="text" field="VisitorPassDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--VisitorTypeDesc-->
				<th>
					<p-columnFilter field="VisitorTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterVisitorTypeDesc
								[ngModel]="value"
								[options]="lstVisitorTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--VisiteeName-->
				<th>
					<p-columnFilter field="VisiteeName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterVisiteeName
								[ngModel]="value"
								[options]="lstVisiteeName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--VisitorReasonDesc-->
				<th>
					<p-columnFilter field="VisitorReasonDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterVisitorReasonDesc
								[ngModel]="value"
								[options]="lstVisitorReasonDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--VisitorStatusDesc-->
				<th>
					<p-columnFilter field="VisitorStatusDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterVisitorStatusDesc
								[ngModel]="value"
								[options]="lstVisitorStatusDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--AdminName-->
				<th>
					<p-columnFilter field="AdminName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterAdminName
								[ngModel]="value"
								[options]="lstAdminName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--IsOffenderHitDesc-->
				<th>
					<p-columnFilter field="IsOffenderHitDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterIsOffenderHitDesc
								[ngModel]="value"
								[options]="lstIsOffenderHitDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--IsAliasDesc-->
				<th>
					<p-columnFilter field="IsAliasDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterIsAliasDesc
								[ngModel]="value"
								[options]="lstIsAliasDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="Barcode">Barcode<p-sortIcon field="Barcode"></p-sortIcon></th>
				<th pSortableColumn="VisitorPassDT">Date<p-sortIcon field="VisitorPassDT"></p-sortIcon></th>
				<th pSortableColumn="VisitorTypeDesc">Type<p-sortIcon field="VisitorTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="VisiteeName">Visitee<p-sortIcon field="VisiteeName"></p-sortIcon></th>
				<th pSortableColumn="VisitorReasonDesc">Reason<p-sortIcon field="VisitorReasonDesc"></p-sortIcon></th>
				<th pSortableColumn="VisitorStatusDesc">Status<p-sortIcon field="VisitorStatusDesc"></p-sortIcon></th>
				<th pSortableColumn="AdminName">Station Admin<p-sortIcon field="AdminName"></p-sortIcon></th>
				<th pSortableColumn="IsOffenderHitDesc">Any Offender Hits<p-sortIcon field="IsOffenderHitDesc"></p-sortIcon></th>
				<th pSortableColumn="IsAliasDesc">From Alias<p-sortIcon field="IsAliasDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-VisitorPass>
			<tr [pSelectableRow]="VisitorPass" (dblclick)="onRowDblClick(VisitorPass)">
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ VisitorPass.Barcode }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ VisitorPass.VisitorPassDTDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ VisitorPass.VisitorTypeDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ VisitorPass.VisiteeName }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ VisitorPass.VisitorReasonDesc }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="VisitorPass.AllowAdmittance == true ? 'Black' : 'Red'"
				>
					{{ VisitorPass.VisitorStatusDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ VisitorPass.AdminName }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="VisitorPass.IsOffenderHit == false ? 'Black' : 'Red'"
				>
					{{ VisitorPass.IsOffenderHitDesc }}
				</td>

				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="VisitorPass.IsAlias == false ? 'Black' : 'Orange'"
				>
					{{ VisitorPass.IsAliasDesc }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
